import './Landingpage.scss';

import profil1 from 'assets/images/landingpage/profil_1.png';
import profil2 from 'assets/images/landingpage/profil_2.png';
import profil3 from 'assets/images/landingpage/profil_3.png';
import profil4 from 'assets/images/landingpage/profil_4.png';
import logoWithWriting from 'assets/images/logos/logo-with-writing-white.svg';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import DoNotDisturbOnRoundedIcon from '@mui/icons-material/DoNotDisturbOnRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import MasksRoundedIcon from '@mui/icons-material/MasksRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import { Button, CircularProgress, Dialog, IconButton, ThemeProvider, Typography, createTheme } from '@mui/material';
import { deDE } from '@mui/material/locale';
import React, { useMemo, useState } from 'react';
import { Link, Redirect, Route, useHistory } from 'react-router-dom';

import ForgotPasswordModal from 'components/ForgotPasswordModal';
import ForgotPasswordModalx from 'components/ForgotPasswordModalx';
import LoginModal from 'components/NewRegister/Login';
import SignInComponent from 'components/SignInComponent';
import FBLoginButton from 'services/Facebook/FBLoginButton';
import useLoginHandler from 'services/Facebook/useLoginHandler';
import GoogleLoginButton from 'services/Google/GoogleLoginButton';
import useGoogleLoginHandler from 'services/Google/useGoogleLoginHandler';
import { DefaultTheme } from '../../theme/DefaultTheme';
import { FORGOT_PASSWORD_PATH, FORGOT_PASSWORD_PATHH, LOGIN_PATH, MAIN_PATH, REGISTER_PATH, REGISTER_USER } from '../../models/Paths';

type BenefitItem = {
    icon: React.ReactNode;
    label: string;
};

type ChatCard = {
    title: string;
    subtitle: string;
    image: string;
    modifier: string;
};

const brandName = 'Sexsocial';

const benefitItems: BenefitItem[] = [
    {
        icon: <MasksRoundedIcon />,
        label: 'Diskret & anonym',
    },
    {
        icon: <LocalFireDepartmentRoundedIcon />,
        label: 'Schnelle Matches',
    },
    {
        icon: <PlaceRoundedIcon />,
        label: 'Menschen in deiner Nähe',
    },
    {
        icon: <DoNotDisturbOnRoundedIcon />,
        label: 'Keine Verpflichtungen',
    },
];

const floatingCards: ChatCard[] = [
    {
        title: 'Lena, 24',
        subtitle: 'Diskret und spontan heute Abend?',
        image: profil1,
        modifier: 'landingpage__floating-card--top-left',
    },
    {
        title: 'Mara, 26',
        subtitle: 'Nur echte Treffen, keine Spielchen.',
        image: profil2,
        modifier: 'landingpage__floating-card--center',
    },
    {
        title: 'Nina, 23',
        subtitle: '2 km entfernt',
        image: profil3,
        modifier: 'landingpage__floating-card--bottom-right',
    },
];

export interface ILandingpageProps {}

export const Landingpage = React.memo(() => {
    const history = useHistory();
    const [socialLoading, setSocialLoading] = useState(false);
    const handleFBLogin = useLoginHandler();
    const handleGoogleLogin = useGoogleLoginHandler();

    const rootStyle = useMemo(
        () =>
            ({
                '--lp-primary': '#ff547f',
                '--lp-primary-strong': '#ff375e',
                '--lp-primary-soft': '#ff9ab0',
                '--lp-ink': '#fff3f4',
                '--lp-soft-ink': '#f2cfd7',
                '--lp-muted': '#c89aa5',
                '--lp-panel': 'rgba(31, 8, 14, 0.72)',
                '--lp-panel-strong': 'rgba(21, 5, 10, 0.82)',
                '--lp-border': 'rgba(255, 173, 189, 0.18)',
            }) as React.CSSProperties,
        []
    );

    return (
        <ThemeProvider theme={createTheme(DefaultTheme, deDE)}>
            <div className="landingpage landingpage--adult" style={rootStyle}>
                <div className="landingpage__noise" />
                <div className="landingpage__heart landingpage__heart--one" />
                <div className="landingpage__heart landingpage__heart--two" />
                <div className="landingpage__heart landingpage__heart--three" />

                <header className="landingpage__masthead">
                    <Link to={MAIN_PATH} className="landingpage__brand" aria-label={`${brandName} Startseite`}>
                        <img src={logoWithWriting} alt={brandName} className="landingpage__brand-logo" />
                    </Link>
                </header>

                <main className="landingpage__main">
                    <section className="landingpage__hero">
                        <div className="landingpage__shell landingpage__hero-grid">
                            <div className="landingpage__hero-copy">
                                <Typography component="h1" className="landingpage__hero-title">
                                    Erlebe <span>diskrete,</span>
                                    <br />
                                    aufregende Dates
                                </Typography>

                                <Typography component="p" className="landingpage__hero-text">
                                    Verbinde dich anonym mit Menschen in deiner Nähe.
                                </Typography>
                            </div>

                            <div className="landingpage__auth-card">
                                <Typography component="h2" className="landingpage__auth-title">
                                    Jetzt kostenlos anmelden
                                    <br />
                                    und Abenteuer erleben
                                </Typography>

                                <Button
                                    variant="contained"
                                    startIcon={<EmailRoundedIcon />}
                                    className="landingpage__primary-button landingpage__auth-primary"
                                    onClick={() => {
                                        history.push(REGISTER_USER);
                                    }}
                                >
                                    Weiter mit E-Mail
                                </Button>

                                <div className="landingpage__auth-divider">
                                    <span />
                                    <strong>ODER</strong>
                                    <span />
                                </div>

                                <div className="landingpage__social-button landingpage__social-button--google">
                                    <GoogleLoginButton setLoading={setSocialLoading} onLoginFinished={handleGoogleLogin} />
                                </div>

                                <div className="landingpage__social-button">
                                    <FBLoginButton
                                        setLoading={setSocialLoading}
                                        onLoginFinished={handleFBLogin}
                                        text="Mit Facebook anmelden"
                                        style={{
                                            color: '#fff7f9',
                                            background: 'linear-gradient(180deg, #404c84 0%, #2a315d 100%)',
                                            border: '1px solid rgba(255,255,255,0.18)',
                                            boxShadow: '0 14px 28px rgba(0,0,0,0.18)',
                                        }}
                                    />
                                </div>

                                {/* <div className="landingpage__social-button">
                                    <AppleLoginButton
                                        setLoading={setSocialLoading}
                                        onLoginFinished={handleAppleLogin}
                                        text="Mit Apple fortfahren"
                                        style={{
                                            color: '#fff4f5',
                                            background: 'linear-gradient(180deg, #2d1018 0%, #1a070d 100%)',
                                            border: '1px solid rgba(255,255,255,0.14)',
                                            boxShadow: '0 14px 28px rgba(0,0,0,0.24)',
                                        }}
                                        startIcon={<Icon icon={faApple} color="#fff4f5" />}
                                    />
                                </div> */}

                                <Button
                                    variant="outlined"
                                    className="landingpage__login-link landingpage__login-button"
                                    onClick={() => {
                                        history.push(LOGIN_PATH);
                                    }}
                                >
                                    Schon Mitglied? Hier einloggen
                                </Button>

                                {socialLoading && (
                                    <div className="landingpage__loading">
                                        <CircularProgress size={18} thickness={5} />
                                        <span>Anmeldung wird vorbereitet ...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>

                    <section className="landingpage__panel landingpage__panel--features">
                        <div className="landingpage__shell landingpage__features-grid">
                            <div className="landingpage__features-copy">
                                <Typography component="h2" className="landingpage__section-title">
                                    Diskrete Begegnungen
                                    <br />
                                    <span>ohne Verpflichtungen</span>
                                </Typography>

                                <div className="landingpage__benefit-list">
                                    {benefitItems.map((item) => (
                                        <div key={item.label} className="landingpage__benefit-item">
                                            <span className="landingpage__benefit-icon">{item.icon}</span>
                                            <span>{item.label}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="landingpage__floating-stage" aria-hidden="true">
                                {floatingCards.map((card) => (
                                    <article key={card.title} className={`landingpage__floating-card ${card.modifier}`}>
                                        <img src={card.image} alt="" />
                                        <div className="landingpage__floating-card-body">
                                            <strong>{card.title}</strong>
                                            <span>{card.subtitle}</span>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="landingpage__panel landingpage__panel--cta">
                        <div className="landingpage__shell landingpage__cta-grid">
                            <div className="landingpage__cta-visual" aria-hidden="true">
                                <article className="landingpage__cta-profile">
                                    <img src={profil4} alt="" />
                                    <div className="landingpage__cta-profile-card">
                                        <strong>Mara, 27</strong>
                                        <span>2,3 km entfernt</span>
                                    </div>
                                </article>
                            </div>

                            <div className="landingpage__cta-copy">
                                <Typography component="h2" className="landingpage__cta-title">
                                    Bereit für dein
                                    <br />
                                    nächstes <span>Abenteuer?</span>
                                </Typography>

                                <Button
                                    variant="contained"
                                    className="landingpage__primary-button landingpage__footer-button"
                                    onClick={() => {
                                        history.push(REGISTER_USER);
                                    }}
                                >
                                    Jetzt kostenlos starten
                                </Button>
                            </div>
                        </div>
                    </section>
                </main>

                <footer className="landingpage__footer">
                    <div className="landingpage__shell landingpage__footer-inner">
                        <Link to="/support" className="landingpage__footer-link">
                            Kontakt
                        </Link>
                        <Link to="/impressum" className="landingpage__footer-link">
                            Impressum
                        </Link>
                        <Link to="/datenschutz" className="landingpage__footer-link">
                            Datenschutz
                        </Link>
                        <Link to="/agb" className="landingpage__footer-link">
                            AGB
                        </Link>
                        <Link to="/content-guidelines" className="landingpage__footer-link">
                            Content &amp; Community Guidelines
                        </Link>
                    </div>
                    <p className="landingpage__legal-copy">
                        Diese Webseite darf ausschlie&szlig;lich von Personen genutzt werden, die mindestens 18 Jahre alt sind. Die Plattform stellt
                        einen virtuellen Chat-Dienst f&uuml;r unterhaltsame, flirtende und fantasievolle Gespr&auml;che zur Verf&uuml;gung. Hierbei
                        werden fiktive Profile verwendet, mit denen keine pers&ouml;nlichen oder realen Treffen m&ouml;glich sind. Die Kosten je
                        Nachricht k&ouml;nnen je nach gew&auml;hlter Zahlungsart unterschiedlich ausfallen. Bitte informieren Sie sich vor der Nutzung
                        der Webseite &uuml;ber die geltenden Nutzungsbedingungen und Datenschutzbestimmungen.
                    </p>
                </footer>

                <Route path={REGISTER_PATH} exact render={() => <Redirect to={REGISTER_USER} />} />
                <Route
                    path={LOGIN_PATH}
                    exact
                    render={() => (
                        <LoginModal
                            open
                            onClose={() => {
                                history.push(MAIN_PATH);
                            }}
                        />
                    )}
                />
                <Route
                    path="/__legacy-login-sexsocial"
                    exact
                    render={() => (
                        <Dialog
                            open
                            onClose={() => {
                                history.push(MAIN_PATH);
                            }}
                            maxWidth="sm"
                            fullWidth
                            PaperProps={{ className: 'landingpage__auth-paper' }}
                        >
                            <IconButton
                                className="landingpage__auth-close"
                                onClick={() => {
                                    history.push(MAIN_PATH);
                                }}
                                aria-label="Schließen"
                            >
                                <CloseRoundedIcon />
                            </IconButton>
                            <div className="landingpage__auth-content">
                                <SignInComponent
                                    handleNextStep={() => {
                                        history.push(REGISTER_USER);
                                    }}
                                />
                            </div>
                        </Dialog>
                    )}
                />
                <Route path={FORGOT_PASSWORD_PATH} exact render={() => <ForgotPasswordModal open />} />
                <Route path={FORGOT_PASSWORD_PATHH} exact render={() => <ForgotPasswordModalx />} />
            </div>
        </ThemeProvider>
    );
});

export default Landingpage;
